document.addEventListener('variant:changed', function(event) {

  // Toggle variant containers
  var variant_containers = document.querySelectorAll('.variant-container');
  var variant_containers_selected = document.querySelectorAll('.variant-container[data-variant-id="'+ event.detail.variant.id +'"]');
  
  var index = 0, length = variant_containers.length;
  for ( ; index < length; index++) {
    variant_containers[index].style.display = 'none';
  }
  
  var index = 0, length = variant_containers_selected.length;
  for ( ; index < length; index++) {
    variant_containers_selected[index].style.display = 'block';
  }
  
  // Add info if product has long shipping time
  var variant_data_el = document.querySelector('.product-form__info-list .variant-container[data-variant-id="'+ event.detail.variant.id +'"]');
  if (variant_data_el) {
    
    var order_property = document.querySelector('form.product-form [data-longer-shipping-time]');
    if (order_property) {
      order_property.remove();
    }
    
    if (variant_data_el.getAttribute('data-inventory-quantity') <= 0 
        && variant_data_el.getAttribute('data-inventory-inventory-policy') == 'continue'
        && variant_data_el.getAttribute('data-inventory-requires-shipping')
    ) {
      order_property = document.createElement('INPUT');
      order_property.setAttribute('type', 'hidden');
      order_property.setAttribute('name', 'properties[Huom]');
      order_property.setAttribute('value', 'Pidempi toimitusaika 2-6 vuorokautta');
      order_property.setAttribute('data-longer-shipping-time', 1);
      
      document.querySelector('form.product-form').append(order_property);
    }
  }
  
});
